import { render, staticRenderFns } from "./FarmUnitDropdown.vue?vue&type=template&id=5bc37bab&"
import script from "./FarmUnitDropdown.vue?vue&type=script&lang=ts&"
export * from "./FarmUnitDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports